import { HttpContextToken } from '@angular/common/http';

export const PROJECT_CONTEXT_TOKEN = new HttpContextToken<string | null>(() => null);
